const Info = ({Element, timezone}) => (
    <Element>
        <tr>
            <th>{timezone}</th>
        </tr>
    </Element>
);

export default Info;
